const CASE_VIEWER_FLAGS = {
  movedToEditorialBox: false,
  movedToSlideLibrary: true,
  sharedToEditor: false,
};

export const getEducationalCaseViewerRoute = (item) => {
  if (!item.caseId || item.itemType === "PRESENTATION_SLIDE") return null;
  const caseSlideIds = String(item.caseSlideIds || "")
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean)
    .join(",");
  if (!caseSlideIds) return null;

  return {
    name: "display-viewer",
    params: {
      id: caseSlideIds.split(",")[0],
      caseDetailId: item.caseId,
      ...CASE_VIEWER_FLAGS,
      isPublicSite: false,
      caseSlideIds,
      selectedFolderView: "",
      selectedFolderUserRole: "",
      selectedFolderUserRegion: "",
      selectedCaseRegion: "",
    },
    query: null,
  };
};

export const getEducationalCaseViewerUrl = async (
  item,
  { router, encryptData, getCaseSlideIds } = {},
) => {
  // Preserve URLs supplied by existing report producers.
  if (item.caseUrl) return item.caseUrl;
  if (!item.caseId || item.itemType === "PRESENTATION_SLIDE" || !router || !encryptData) return "";

  let route = getEducationalCaseViewerRoute(item);
  if (!route && getCaseSlideIds) {
    const caseSlideIds = await getCaseSlideIds(item.caseId, { ...CASE_VIEWER_FLAGS });
    route = getEducationalCaseViewerRoute({ ...item, caseSlideIds });
  }
  if (!route) return "";

  // PDF recipients can open the case without an authenticated editor session.
  route.params.isPublicSite = true;

  // Match $changeRouteToTab, using the router to retain the configured base path.
  const params = {};
  Object.keys(route.params).forEach((key) => {
    params[key] = encryptData(route.params[key]);
  });
  const { href } = router.resolve({ ...route, params });
  return new URL(href, window.location.origin).href;
};
